<template>
    <div class="discover video-list">
        <div class="columns">
            <div class="column">
                <h1 class="purple">
                    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38">
        <!-- eslint-disable-next-line max-len -->
        <path class="st0" d="M28.8 14.4C28.8 6.5 22.3 0 14.4 0 6.5 0 0 6.5 0 14.4c0 7.9 6.5 14.4 14.4 14.4C22.3 28.8 28.8 22.3 28.8 14.4zM14.4 27.4c-7.1 0-13-5.8-13-13 0-7.1 5.8-13 13-13 7.1 0 13 5.8 13 13C27.4 21.5 21.5 27.4 14.4 27.4z"
        />
        <!-- eslint-disable-next-line max-len -->
        <path class="st0" d="M11.8 4.7c-4.4 1.2-7.5 5.2-7.5 9.8 0 1.8 0.5 3.5 1.3 5 0.1 0.2 0.4 0.4 0.6 0.4 0.1 0 0.2 0 0.4-0.1 0.3-0.2 0.5-0.6 0.3-1 -0.8-1.3-1.2-2.8-1.2-4.3 0-3.9 2.6-7.4 6.4-8.4 0.4-0.1 0.6-0.5 0.5-0.9C12.6 4.8 12.2 4.5 11.8 4.7z"
        />
        <!-- eslint-disable-next-line max-len -->
        <path class="st0" d="M37.8 33l-8.3-8.3c-0.8-0.8-2.2-0.8-3.1 0l-1.5 1.5c-0.8 0.8-0.8 2.2 0 3.1l8.3 8.3c0.5 0.5 1.3 0.8 2.1 0.8 0.4 0 0.8-0.1 1.1-0.2l0.1-0.1 1.8-1.8 0.1-0.1C38.8 35.1 38.5 33.7 37.8 33zM37.1 35.4l-1.4 1.4c-0.4 0.1-1.1 0-1.4-0.3l-8.3-8.3c-0.3-0.3-0.3-0.7 0-1l1.5-1.5c0.1-0.1 0.3-0.2 0.5-0.2 0.2 0 0.4 0.1 0.5 0.2l8.3 8.3C37.1 34.3 37.2 35 37.1 35.4z"
        />
      </svg>
                    מצא\י שיעור
                </h1>
            </div>
        </div>

        <search-bar></search-bar>
    </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";

export default {
  name: `Discover`,
  components: {
    SearchBar
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.$store.dispatch(`clearResults`);
    });
  }


  // created() {
  //   if (this.isLoggedIn === 0) {
  //     this.$router.push(`/profile`);
  //   }
  // },
};
</script>

<style lang="scss">
.discover {
  max-width: 1344px;
  margin: 0 auto;

  h1 {
    margin: 20px 0;
  }
}
</style>
